import apiGroupsTrainers from '@/api/groups-trainers'

const state = {
  error: null,
  isSubmitting: false
}

export const mutationTypes = {
  createGroupsTrainersStart:
    '[create groups trainers] Create groups trainers start',
  createGroupsTrainersSuccess:
    '[create groups trainers] Create groups trainers success',
  createGroupsTrainersFailure:
    '[create groups trainers] Create groups trainers failure'
}

export const actionTypes = {
  createGroupsTrainers: '[create groups trainers] Create groups trainers'
}

const mutations = {
  [mutationTypes.createGroupsTrainersStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.createGroupsTrainersSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.createGroupsTrainersFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  }
}

const actions = {
  [actionTypes.createGroupsTrainers](context, {trainer}) {
    context.commit(mutationTypes.createGroupsTrainersStart)
    return new Promise(resolve => {
      apiGroupsTrainers
        .addGroupsTrainers(trainer)
        .then(response => {
          context.commit(mutationTypes.createGroupsTrainersSuccess)
          resolve(response.data)
        })
        .catch(resolve => {
          context.commit(
            mutationTypes.createGroupsTrainersFailure,
            resolve.response.data.errors
          )
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
